import { ReactElement, useMemo } from 'react';
import { TextField } from '@mui/material';
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { ErrorPresentation } from 'helpers/validators';

export interface GetAutocompleteRenderInputProps {
  autoFocus?: boolean;
  id: string;
  required: boolean;
  error: ErrorPresentation | string;
  disabled: boolean;
  label: string;
  placeholder: string | undefined;
  helperText?: string;
  dense: boolean;
  multiline?: boolean;
  minRows?: number;
}

export const getAutocompleteRenderInput = ({
  autoFocus,
  id,
  required,
  error,
  disabled,
  label,
  placeholder,
  helperText,
  dense,
  multiline = false,
  minRows,
}: GetAutocompleteRenderInputProps): ((
  params: AutocompleteRenderInputParams
) => ReactElement) => {
  return function AutocompleteRenderInput(params: AutocompleteRenderInputParams) {
    const inputProps = useMemo(() => {
      return multiline
        ? {
            ...params.InputProps,
            style: {
              whiteSpace: 'pre-wrap',
            },
          }
        : {
            ...params.InputProps,
          };
    }, [multiline, params.InputProps]);

    return (
      <TextField
        autoFocus={autoFocus}
        variant='outlined'
        {...params}
        multiline={multiline}
        minRows={minRows}
        required={required}
        error={Boolean(error)}
        label={label}
        disabled={disabled}
        helperText={helperText}
        id={`${id}-textField`}
        placeholder={placeholder}
        margin={dense ? 'dense' : 'none'}
        InputProps={inputProps}
      />
    );
  };
};
